import { create } from 'zustand';

// Экран выбора оператора рабочего места (спека 2026-09-25 workplace-operator-pin).
// Открывается: (а) автоматически по 401 operator_required от API, (б) вручную из шапки.
interface OperatorGateState {
  manualOpen: boolean;
  /** Счётчик авто-запросов gate (401 operator_required) — чтобы OperatorGate перечитал /me */
  requiredTick: number;
  openManual: () => void;
  closeManual: () => void;
  notifyRequired: () => void;
}

export const useOperatorGateStore = create<OperatorGateState>((set) => ({
  manualOpen: false,
  requiredTick: 0,
  openManual: () => set({ manualOpen: true }),
  closeManual: () => set({ manualOpen: false }),
  notifyRequired: () => set((s) => ({ requiredTick: s.requiredTick + 1 })),
}));
